import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const FETCH_ALL_PACKAGE_REQUEST = 'package/FETCH_ALL_PACKAGE_REQUEST'
const FETCH_ALL_PACKAGE_SUCCESS = 'package/FETCH_ALL_PACKAGE_SUCCESS'
const FETCH_ALL_PACKAGE_FAILURE = 'package/FETCH_ALL_PACKAGE_FAILURE'

const FETCH_IS_ACTIVE_PACKAGE_REQUEST =
  'package/FETCH_IS_ACTIVE_PACKAGE_REQUEST'
const FETCH_IS_ACTIVE_PACKAGE_SUCCESS =
  'package/FETCH_IS_ACTIVE_PACKAGE_SUCCESS'
const FETCH_IS_ACTIVE_PACKAGE_FAILURE =
  'package/FETCH_IS_ACTIVE_PACKAGE_FAILURE'

const CREATE_PACKAGE_REQUEST = 'package/CREATE_PACKAGE_REQUEST'
const CREATE_PACKAGE_SUCCESS = 'package/CREATE_PACKAGE_SUCCESS'
const CREATE_PACKAGE_FAILURE = 'package/CREATE_PACKAGE_FAILURE'

const UPDATE_PACKAGE_REQUEST = 'package/UPDATE_PACKAGE_REQUEST'
const UPDATE_PACKAGE_SUCCESS = 'package/UPDATE_PACKAGE_SUCCESS'
const UPDATE_PACKAGE_FAILURE = 'package/UPDATE_PACKAGE_FAILURE'

const DELETE_PACKAGE_REQUEST = 'package/DELETE_PACKAGE_REQUEST'
const DELETE_PACKAGE_SUCCESS = 'package/DELETE_PACKAGE_SUCCESS'
const DELETE_PACKAGE_FAILURE = 'package/DELETE_PACKAGE_FAILURE'

// Initialize State
const initialState = {
  isLoading: true,
  error: {},
  packageList: [],
  packageIsActiveList: []
}

// Default Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ALL_PACKAGE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_ALL_PACKAGE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        packageList: action.payload
      }
    case FETCH_ALL_PACKAGE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case FETCH_IS_ACTIVE_PACKAGE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_IS_ACTIVE_PACKAGE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        packageIsActiveList: action.payload
      }
    case FETCH_IS_ACTIVE_PACKAGE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case CREATE_PACKAGE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case CREATE_PACKAGE_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case CREATE_PACKAGE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_PACKAGE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_PACKAGE_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_PACKAGE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_PACKAGE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_PACKAGE_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_PACKAGE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    default:
      return state
  }
}

export const getAllPackageList = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_ALL_PACKAGE_REQUEST
      })

      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      const response = await API.get(EndPoints.PACKAGE, {
        headers: {
          Authorization: authorizationHeader
        }
      })

      dispatch({
        type: FETCH_ALL_PACKAGE_SUCCESS,
        payload: response.data
      })
    } catch (error) {
      dispatch({
        type: FETCH_ALL_PACKAGE_FAILURE
      })
    }
  }
}

export const getIsActivePackageList = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_IS_ACTIVE_PACKAGE_REQUEST
      })

      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      const response = await API.get(EndPoints.PACKAGE + '/isActive', {
        headers: {
          Authorization: authorizationHeader
        }
      })

      dispatch({
        type: FETCH_IS_ACTIVE_PACKAGE_SUCCESS,
        payload: response.data
      })
    } catch (error) {
      dispatch({
        type: FETCH_IS_ACTIVE_PACKAGE_FAILURE
      })
    }
  }
}

export const createPackage = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CREATE_PACKAGE_REQUEST
      })

      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.post(EndPoints.PACKAGE, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })

      dispatch({
        type: CREATE_PACKAGE_SUCCESS
      })
    } catch (error) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: CREATE_PACKAGE_FAILURE
      })
    }
  }
}

export const updatePackage = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_PACKAGE_REQUEST
      })

      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.PACKAGE, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })

      dispatch({
        type: UPDATE_PACKAGE_SUCCESS
      })
    } catch (error) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_PACKAGE_FAILURE
      })
    }
  }
}

export const deletePackage = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_PACKAGE_REQUEST
      })

      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.delete(EndPoints.PACKAGE + '/' + id, {
        headers: {
          Authorization: authorizationHeader
        }
      })

      dispatch({
        type: DELETE_PACKAGE_SUCCESS
      })
    } catch (error) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_PACKAGE_FAILURE
      })
    }
  }
}
